// extracted by mini-css-extract-plugin
export default {"places":"Places_places__9XpwQ","places_card":"Places_places_card__c37o2","placesdetails":"Places_placesdetails__D-Th0","menu":"Places_menu__dN4kZ"};